import type {ParticipantSampleInterface} from "./ParticipantSampleTypes";

export interface ParticipantSamplePartsErrors {
    sent_count?: string;
    paid_count?: string;
}

export function getParticipantSamplePartsErrors(
    sample: ParticipantSampleInterface,
    isWorking = true,
): ParticipantSamplePartsErrors {
    if (!sample.can_contain_parts) return {};

    const sentCount = sample.sent_count;
    const paidCount = sample.paid_count;
    const errors: ParticipantSamplePartsErrors = {};

    const hasValidSentCount = typeof sentCount === "number" && Number.isInteger(sentCount) && sentCount > 0;
    const hasValidPaidCount = typeof paidCount === "number" && Number.isInteger(paidCount) && paidCount > 0;

    if (!hasValidSentCount) {
        errors.sent_count = "Укажите количество отправленных образцов больше нуля.";
    }
    if (isWorking && !hasValidPaidCount) {
        errors.paid_count = "Укажите количество оплаченных образцов больше нуля.";
    } else if (isWorking && hasValidSentCount && hasValidPaidCount && paidCount > sentCount) {
        errors.paid_count = "Количество оплаченных образцов не может быть больше отправленных.";
    }

    return errors;
}

export function areParticipantSamplePartsValid(
    samples: ParticipantSampleInterface[],
    isWorking = true,
): boolean {
    return samples.every(sample => Object.keys(getParticipantSamplePartsErrors(sample, isWorking)).length === 0);
}
